var $fca04de68cb5ade1$exports = {};
$fca04de68cb5ade1$exports = {
  "alert": "Avviso",
  "dismiss": "Ignora"
};
export { $fca04de68cb5ade1$exports as default };